const formTemplate = {
  form: {
    children: [
      {
        type: 'Text',
        key: 'text',
        props: {
          value: 'Form example for templates',
          fontSize: 'xl',
          tag: 'h1',
        },
      },
      {
        type: 'Input',
        key: 'input',
        props: {
          label: {
            value: 'Input filed',
          },
          placeholder: {
            value: 'placeholder',
          },
        },
      },
      {
        type: 'Select',
        key: 'select',
        props: {
          options: [
            {
              value: 'Option 1',
              key: 'Option 1',
            },
            {
              value: 'Option 2',
              key: 'Option 2',
            },
            {
              value: 'Option 3',
              key: 'Option 3',
            },
          ],
          defaultValue: 'Option 2',
          label: {
            value: 'Select',
          },
        },
      },
      {
        type: 'Textarea',
        key: 'textarea',
        props: {
          label: {
            value: 'Textarea',
          },
          placeholder: {
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          },
        },
      },
      {
        type: 'Checkbox',
        key: 'checkbox',
        props: {
          label: {
            value: 'Checkbox',
          },
          allowIndeterminate: false,
        },
      },
      {
        type: 'Checkbox',
        key: 'checkbox-2',
        props: {
          label: {
            value: 'Checkbox indeterminate',
          },
          allowIndeterminate: true,
        },
      },
      {
        type: 'Radio',
        key: 'radio',
        props: {
          options: [
            {
              value: 'First',
              key: 'first',
            },
            {
              value: 'Second',
              key: 'second',
            },
          ],
          direction: 'column',
        },
      },
      {
        type: 'DatePicker',
        key: 'datepicker',
        props: {
          label: {
            value: 'Date',
          },
        },
      },
      {
        type: 'Submit',
        key: 'submit',
        props: {
          label: {
            value: 'Submit',
          },
        },
      },
    ],
  },
  schema: {
    type: 'object',
    keys: {
      input: {
        flags: {
          presence: 'required',
          label: 'Input filed',
        },
        type: 'string',
      },
      select: {
        flags: {
          label: 'Select',
        },
        allow: [
          'Option 1',
          'Option 2',
          'Option 3',
        ],
        type: 'string',
      },
      checkbox: {
        flags: {
          label: 'Checkbox',
        },
        allow: [
          '',
        ],
        type: 'boolean',
      },
      textarea: {
        flags: {
          label: 'Textarea',
        },
        allow: [
          '',
        ],
        type: 'string',
      },
      text: {
        allow: [
          '',
        ],
        type: 'string',
      },
      'checkbox-2': {
        flags: {
          label: 'Checkbox indeterminate',
        },
        allow: [
          null,
        ],
        type: 'boolean',
      },
      datepicker: {
        flags: {
          label: 'Date',
        },
        allow: [
          '',
        ],
        type: 'string',
      },
      radio: {
        allow: [
          '',
        ],
        type: 'string',
      },
    },
    preferences: {
      messages: {
        'string.empty': '<b>{#label}</b> is required',
        'any.required': '<b>{#label}</b> is required',
      },
      errors: {
        wrap: {
          label: false,
        },
      },
    },
  },
};
export default formTemplate;
